import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './routes'
import { parseQuery, readSavedQuery, sanitizeQuery } from '@/utils/query'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  parseQuery,
  routes
})

// router.beforeEach(function (to, from, next) {
//   // setTimeout(() => {
//   //   window.scrollTo({
//   //     top: 0,
//   //     behavior: 'instant'
//   //   })
//   // }, 200)
//   next()
// })
export let redirectTimeout = 100

router.afterEach((to, from) => {
  from.fullPath === '/' ? (redirectTimeout = 100) : (redirectTimeout = 300)

  setTimeout(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    })
  }, redirectTimeout)

  const currentQuery = sanitizeQuery(to.query)
  let savedQuery = {}

  try {
    savedQuery = readSavedQuery(localStorage)
  } catch (e) {
    savedQuery = {}
  }

  if (Object.keys(savedQuery).length) {
    const query = {
      ...savedQuery,
      ...currentQuery
    }

    if (JSON.stringify(query) !== JSON.stringify(currentQuery)) {
      router.replace({ path: to.path, hash: to.hash, query }).catch(() => {})
    }
  }
})

export default router
